export default __webpack_public_path__ + "static/media/EM0790.34I-22668_-15166_0.5bcdf356.jpg";